import React, { useState } from 'react';
import { Form as FinalForm } from 'react-final-form';
import classNames from 'classnames';
import { useDispatch } from 'react-redux'
import { postNewComent } from '../../../containers/ListingPage/ListingPage.duck'

import { FormattedMessage, useIntl } from '../../../util/reactIntl';
import { required } from '../../../util/validators';

import { FieldTextInput, Form, PrimaryButton } from '../../../components';
import css from './InternalCommentsForm.module.css';

const InternalCommentsForm = props => {
    const {
        listingId
    } = props;
    const subUserId = window.localStorage.getItem("subUserId")
    const dispatch = useDispatch()

    const [loading, setLoading] = useState(false);

    const handleSubmit = async (values) => {
        setLoading(true);
        const comment = values.comment
        const params = { listingId, subUserId, comment }

        try {
            await dispatch(postNewComent(params))
        } catch (err) {
            setLoading(false);
        }


    };

    return (
        <FinalForm
            {...props}
            onSubmit={handleSubmit}
            render={fieldRenderProps => {
                const {
                    className,
                    rootClassName,
                    disabled,
                    handleSubmit,
                    formId,
                    invalid,
                } = fieldRenderProps;

                const intl = useIntl();
                // const commentLabel = intl.formatMessage({ id: 'InternalComments.commentLabel' });
                const commentPlaceholderMessage = intl.formatMessage({
                    id: 'InternalComments.commentPlaceholder',
                });
                const commentRequiredMessage = intl.formatMessage({
                    id: 'InternalComments.commentRequired',
                });

                const classes = classNames(rootClassName || css.root, className);
                const submitDisabled = invalid || disabled || loading;

                return (

                    <Form className={classes} onSubmit={handleSubmit}>
                        <div className={css.formWrapper}>
                            <FieldTextInput
                                className={css.input}
                                type="text"
                                id={formId ? `${formId}.internalComments` : 'internalComments'}
                                name="comment"
                                // label={commentLabel}
                                placeholder={commentPlaceholderMessage}
                                validate={required(commentRequiredMessage)}
                            />

                            <PrimaryButton
                                className={css.submitButton}
                                type="submit"
                                inProgress={loading}
                                disabled={submitDisabled}
                            >
                                <FormattedMessage id="InternalCommentsForm.submitButton" />
                            </PrimaryButton>
                        </div>
                    </Form>
                );
            }}
        />
    );
};

export default InternalCommentsForm;
